import React from "react";
import Title from "../home/Title";
import {
  bootstrap,
  flexbox,
  git,
  htmlcss,
  javascript,
  node,
  python,
  react,
  sql,
  IBMDataScience,
} from "../../assets";

import CertificationCard from "./CertificationCard";

const Blog = () => {
  return (
    <div>
      <Title title="Latest" subTitle="Certifications" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <CertificationCard
            image={react}
            title="September 01, 2023"
            subTitle="React JS"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={python}
            title="February 22, 2023"
            subTitle="Programming Foundations With Python"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={javascript}
            title="April 01, 2023"
            subTitle="Build Your Own Dynamic Web Application"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={sql}
            title="April 18, 2023"
            subTitle="Instroduction To Database"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={IBMDataScience}
            title="August 30, 2023"
            subTitle="Data Science 101"
            category="Provided by IBM"
          />
        </div>
        <div className="px-6">
          <CertificationCard
            image={htmlcss}
            title="October 04, 2023"
            subTitle="Build Your Own Static Website"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={node}
            title="June 14, 2023"
            subTitle="Node.js"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={bootstrap}
            title="October 28, 2022"
            subTitle="Build Your Own Responsive Website"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={flexbox}
            title="May 08, 2023"
            subTitle="Responsive Web Design Using Flexbox"
            category="From NxtWave CCBP 4.0"
          />
          <CertificationCard
            image={git}
            title="May 17, 2023"
            subTitle="Doveloper Foundations"
            category="From NxtWave CCBP 4.0"
          />
        </div>
      </div>
    </div>
  );
};

export default Blog;
